import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              精彩预告
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              热门影视预告片与精彩片段一网打尽
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="640"
                  height="360"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute top-2 left-2 px-2 py-0.5 text-[11px] bg-accent-500 text-background-50 rounded-md">
                  {item.tag}
                </span>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-[11px] bg-black/70 text-foreground-300 rounded-md">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-800 line-clamp-1">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次播放
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}